import { GeoCoordinates } from "./types";

export const formatZip = (zip?: string | null): string | null | undefined => {
  return zip && zip?.length > 5 ? `${zip.slice(0, 5)}-${zip.slice(5)}` : zip;
};

type AddressParts = {
  address?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
};
export const formatAddress = ({ address, city, state, zip }: AddressParts): string => {
  return [address, city, state]
    .filter(Boolean)
    .join(", ")
    .concat(zip ? ` ${formatZip(zip)}` : "");
};

type DirectionsLinkParams = {
  address: string;
  coordinate?: GeoCoordinates;
  placeId?: string | null;
  placeName?: string | null;
};
export const getGoogleDirectionsLink = ({
  address,
  coordinate,
  placeName,
}: DirectionsLinkParams): string => {
  /**
   * Returns an external Google maps link which gives directions to the specified location.
   * The 1st of the following cases which is fulfilled will be used(best-to-worse):
   * We have remove support for using place for now, and google and aws use different placeId
   */
  if (coordinate) {
    return `https://www.google.com/maps/search/?api=1&query=${coordinate.latitude},${coordinate.longitude}`;
  }
  if (placeName) {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      `${placeName} ${address}`,
    )}`;
  }

  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${address}`)}`;
};
